import React from 'react'
import Avatar from '../Avatar'
import img13 from "../../assets/img/img13.jpg";
import img14 from "../../assets/img/img14.jpg";
import { Link } from 'react-router-dom';
import { Card, Col, Nav } from 'react-bootstrap';

const AppointmentSidebar2 = () => {
  return (
    <Col xl="3" className="d-none mt-6 app-sidebar d-xl-block">

<h5 className="section-title">Recent Items</h5>

            <hr className="my-3 opacity-0" />

            <h5 className="section-title mb-4">Upcomming Appoinments</h5>
            <div className="card card-task">
            <div
                className="card-body p-3 pb-1"
                style={{ border: "1px solid lavender", borderRadius: 3 }}
            >
                <span className="badge bg-danger">Missed</span>
                <span className="badge bg-primary">Updates</span>
                <div className="d-flex flex-row-reverse align-items-center justify-content-between mt-2 mb-1">
                    <span className="card-date">Sep 20</span>
                    <h6 className="card-title">Consultant Gynaecologist</h6>
                </div>
                <p className="fs-xs">
                    Booked to See: <a href="">Chima Ikenna</a>
                </p>
            </div>
            
        </div>
        <div className="card card-task">
        <div
            className="card-body p-3 pb-1"
            style={{ border: "1px solid lavender", borderRadius: 3 }}
        >
            <span className="badge bg-danger">Missed</span>
            <span className="badge bg-primary">Updates</span>
            <div className="d-flex flex-row-reverse align-items-center justify-content-between mt-2 mb-1">
                <span className="card-date">Sep 20</span>
                <h6 className="card-title">Consultant Gynaecologist</h6>
            </div>
            <p className="fs-xs">
                Booked to See: <a href="">Chima Ikenna</a>
            </p>
        </div>


    </div>

    

            <hr className="my-4 opacity-0" />

            {/* <h5 className="section-title">Recent Transactions</h5> */}
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6">Transaction History</Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header>
              <Card.Body className="p-0">
                <ul className="people-group">
                  {[
                    {
                    "bg": "primary",
                      "icon": "ri-coins-line",
                      "label": "Purchase from #10322",
                      "date": "Oct 21, 2023, 3:30pm",
                      "value": "+ $250.00",
                      "status": "Completed",
                      "color": "success"
                    }, {
                        "bg": "primary",
                      "icon": "ri-coins-line",
                      "label": "Process refund to #00910",
                      "date": "Oct 19, 2023, 3:30pm",
                      "value": "- $16.50",
                      "status": "Processing",
                      "color": "warning"
                    }, {
                      "bg": "primary",
                      "icon": "ri-coins-line",
                      "label": "Process delivery to #44333",
                      "date": "Oct 18, 2023, 6:18pm",
                      "value": "3 Items",
                      "status": "For pickup",
                      "color": "info"
                    }, {
                      "bg": "pink",
                      "icon": "ri-truck-line",
                      "label": "Payment from #023328",
                      "date": "Oct 18, 2023, 12:40pm",
                      "value": "+ $129.50",
                      "status": "Completed",
                      "color": "success"
                    }, {
                      "bg": "secondary",
                      "icon": "ri-secure-payment-line",
                      "label": "Payment failed #087651",
                      "date": "Oct 15, 2023, 08:09am",
                      "value": "$150.20",
                      "status": "Declined",
                      "color": "danger"
                    }
                  ].slice(0,3).map((item, index) => (
                    <li className="people-item" key={index}>
                      <div className="avatar">
                        <span className={"avatar-initial fs-20 bg-" + item.bg}>
                          <i className={item.icon}></i>
                        </span>
                      </div>
                      <div className="people-body">
                        <h6><Link to="">{item.label}</Link></h6>
                        <span>{item.date}</span>
                      </div>
                      <div className="text-end">
                        <div className="fs-sm">{item.value}</div>
                        <span className={"d-block fs-xs text-" + item.color}>{item.status}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </Card.Body>
              <Card.Footer className="d-flex justify-content-center">
                <Link to="" className="fs-sm">Manage Transactions</Link>
              </Card.Footer>
            </Card>

          </Col>
  )
}

export default AppointmentSidebar2